import React, { useState } from 'react';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
  Alert,
  CircularProgress,
} from '@mui/material';
import { PlayArrow as PlayIcon } from '@mui/icons-material';
import { getFunctions, httpsCallable } from 'firebase/functions';

const MigrateData: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  const handleMigrate = async () => {
    if (!window.confirm('データ移行を実行しますか？\n\nこの操作により、既存の店舗とスタッフデータが統合ユーザーシステムに移行されます。')) {
      return;
    }

    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const functions = getFunctions(undefined, 'asia-northeast1');
      const runMigration = httpsCallable(functions, 'runMigration');

      const response = await runMigration({});
      setResult(response.data);

      alert('データ移行が完了しました！');
    } catch (err: any) {
      console.error('Migration error:', err);
      setError(err.message || 'データ移行中にエラーが発生しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          データ移行
        </Typography>

        <Typography variant="body1" paragraph>
          既存のデータを統合ユーザーシステムに移行します。
        </Typography>

        <Alert severity="warning" sx={{ mb: 3 }}>
          <Typography variant="subtitle2" gutterBottom>
            この操作は以下を実行します：
          </Typography>
          <ul>
            <li>店舗オーナーをusersコレクションに移行</li>
            <li>スタッフユーザーをusersコレクションに移行</li>
            <li>既存の顧客ユーザーにsystemRoleを追加</li>
          </ul>
        </Alert>

        <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={loading ? <CircularProgress size={20} /> : <PlayIcon />}
            onClick={handleMigrate}
            disabled={loading}
            size="large"
          >
            {loading ? '移行中...' : 'データ移行を実行'}
          </Button>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {result && (
          <Alert severity="success" sx={{ mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
              移行完了
            </Typography>
            <pre style={{ fontSize: '0.875rem', overflow: 'auto' }}>
              {JSON.stringify(result, null, 2)}
            </pre>
          </Alert>
        )}
      </Paper>
    </Container>
  );
};

export default MigrateData;
